import { Injectable,  Component, OnInit  } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DataService } from './data.service';
import { Meta } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class PropertyService {

  constructor(private _dataService: DataService, private _activatedRoute: ActivatedRoute, private meta: Meta) {
    this.PopulateProperty() ;
   }


    bTest: boolean = false;
    cTest: boolean = false;
    propertyFound: boolean = false;
    brandPhoneNumber = '';   
    brandPhoneNumberFormatted = ''; 
    address = '';
    beds = 1;
    bathrooms = 1;
    brand = '';
    brandWebsiteLink = '';
    brandWebsitePropertyLink = '';
    brandWebsiteValuationLink = '';
    dataLayer: any[];
    descriptionIntro: string = '';
    errorMessage = null;
    features: any[];
    firstImage = '';
    floorplan = '';
    image_path = 'assets/';
    latitude = 0;
    location = '';
    locationBuyers = 56;
    longDescription: string = '';
    longitude = 0;
    logoUrl = '';
    OfficeID = '';
    officeLongLat = '';
    OfficeTel = '';
    OfficeAddress = '';
    OfficeEmail = '';
    price = 0;
    propertyData: any[] = [];
    propRef = '';
    receptions = 1;
    referrer = '';
    rndPropertyType = '';
    rndPropertyBeds = '';
    rndPropertyLounge = '';
    rndPropertyBath = '';
    staffPicURL = '';
    staffName = '';
    staffJobTitle = '';
    soldHeader = '';
    propertyLongLat = {
      'Lat': '',
      'Long': ''
    };
    propPrice = 0;
    propBeds = '';
    potNo = 0;

    baseSite = '';

    propLinkReferer = '';

    brandName = '';
    brandFamilyLegalInfo = '';
    brandTnCLnk = '';
    brandPrivacyPolicy = '';

    private _servicePopulated: Subject<any> = new Subject<any>();
    public ServicePopulated: Observable<any> = this._servicePopulated.asObservable();

    PopulateProperty() {
      this._activatedRoute.queryParams.subscribe((params: Params) => {
        this.propRef = params['propRef'];
        this.referrer = params['referrer'];
        this.bTest = params['type'] === '784';
        this.cTest = params['type'] === '487';
        this.PopulatePropertyData(params['propRef']);
      });
    }

    PopulatePropertyData(propRef: string) {

      if (propRef !== undefined) {

        this.brand = propRef.substring(0, 3).toLowerCase();

        this.setLogoUrl(this.brand);

        this._dataService.getPropertyData(propRef)
        .subscribe(propData => (

          console.log(propData),
          this.price = Number(propData[0].Price),
          this.beds = (Number(propData[0].Beds) > 0 ? Number(propData[0].Beds) : 1 ),
          this.bathrooms = (Number(propData[0].Bathrooms) > 0 ? Number(propData[0].Bathrooms) : 1 ),
          this.receptions = (Number(propData[0].Receptions) > 0 ? Number(propData[0].Receptions) : 1 ),
          this.firstImage = propData[0].ImageURL,
          this.address = propData[0].Address1,
          this.location = propData[0].Location,
          this.floorplan = propData[0].ImageMDFloorplan,
          this.OfficeID = propData[0].OfficeID,
          //this.officeLongLat = JSON.parse(propData[0].OfficeLongLat).Lat + ',' + JSON.parse(propData[0].OfficeLongLat).Long,
          this.OfficeTel = propData[0].OfficeTel,
          this.OfficeAddress = propData[0].OfficeAddress,
          this.rndPropertyType = this.image_path + propData[0].PropImage,
          this.rndPropertyBeds = this.image_path + propData[0].BedroomImage,
          this.rndPropertyLounge = this.image_path + propData[0].SofaImage,
          this.rndPropertyBath = this.image_path + propData[0].BathImage,
          this.staffPicURL = this.formatStaffPhoto(propData[0].StaffPicURL),
          this.staffName = propData[0].StaffName,
          this.staffJobTitle = propData[0].StaffJobTitle,
          this.locationBuyers = propData[0].Stat1,
          this.soldHeader = propData[0].SoldHeader,
          this.OfficeEmail = propData[0].BranchPhone,
          this.longDescription = propData[0].LongDescription,
          this.descriptionIntro = propData[0].LongDescription.substring(0, 150) + '...',
          this.propertyLongLat = JSON.parse(propData[0].LongLat),
          this.propPrice = propData[0].Price,
          this.propBeds = propData[0].Beds,
          this.potNo = this.getPotNo(propRef, propData),
          this.editFeatures(JSON.parse(propData[0].Features)),
          window['dataLayer'][0] = {
            'bedrooms': Number(propData[0].Beds),
            'price': Number(propData[0].Price),
            'propertyType': Number(propData[0].PropType),
            'shortPostCode': propData[0].ShortPostCode
          },
          this._servicePopulated.next(),
          this.googleLatLon(propData[0].LongLat, propData[0].Location, propData[0].PostCode),
          this.googleTag(),
          this.propertyFound = true
        ),
        error => this.errorMessage = <any>error);
      }
    }

    getPotNo(propRef, pData) {
      var potNo = 0;

      pData.forEach(function(pItem) {

        if(pItem.PotNumber != "")
        {
          potNo = +pItem.PotNumber;
        }
      });

      if(potNo != 1
        && potNo != 2
        && potNo != 3)
      {
        potNo = this.sortForPotFore(propRef);
      }

      return potNo;
    }

    sortForPotFore(propRef)
    {
      var charNo = 0;
      var potNo = 0;

      charNo = propRef.length - 1;

      while (potNo == 0)
      {
        var sortingChar = propRef[charNo];

        if(sortingChar == 1
            || sortingChar == 4
            || sortingChar == 7)
        {
          potNo = 1;
        }
        else if(sortingChar == 2
          || sortingChar == 5
          || sortingChar == 8)
        {
          potNo = 2;
        }
        else if(sortingChar == 3
          || sortingChar == 6
          || sortingChar == 9)
        {
          potNo = 3;
        }

      charNo--;

      }

      return potNo;
    }

    //some properties have dots or the word FLINK multiple times for features only show those with a title or description more than 5 characters
    editFeatures(propfeatures): void {

      let editedFeatures: any[] = [];

      propfeatures.forEach((feature) => (feature.Title.length > 5  || feature.Description.length > 5) &&

        editedFeatures.push({
            'Title': feature.Title,
            'Description': feature.Description
          }) 
      )

      this.features = editedFeatures;

    }

    //IF no Lat Lon in PAF database, get it from google maps API
    googleLatLon(lonlat, location, postcode): void {

      var address = location + ',+UK,' + postcode;
      address = address.replace(' ', '+');

      if (lonlat === ""  || lonlat === undefined || lonlat === '{ "Lat": , "Long": }') {

        this._dataService.getGoogleLatLon(address)
        .subscribe(coordinates => (
          this.longitude = Number(JSON.stringify(coordinates.results[0].geometry.location.lng)),
          this.latitude = Number(JSON.stringify(coordinates.results[0].geometry.location.lat))
        ),
        error => this.errorMessage = <any>error);

      }
      else {
        this.longitude = Number(JSON.parse(lonlat).Long),
        this.latitude = Number(JSON.parse(lonlat).Lat)
      }

    }

    setLogoUrl(brand): void {

        switch (brand) {
          case 'hrt':
          this.logoUrl = 'assets/images/logos/haartWhite.png';
          this.brandPhoneNumber = '08002230334';
          this.brandPhoneNumberFormatted = '0800 223 0334';
          this.brandWebsiteLink = "https://www.haart.co.uk/?utm_source=social-media&utm_medium=landing_page&utm_campaign=FLINK&utm_term=haart&utm_content=FOR-SALE&referrer=landing_page_social-media_FLINK_FOR-SALE_haart";
          this.brandName = "haart";
          this.brandFamilyLegalInfo = "https://www.haart.co.uk/legal-information/family/";
          this.brandTnCLnk = "https://www.haart.co.uk/legal-information/";
          this.brandPrivacyPolicy = "https://www.haart.co.uk/legal-information/privacy-policy/";
          //this.propLinkReferer = "&referrer=landing_page_social-media_FLINK_FOR-SALE_haart";
          this.baseSite = "https://www.haart.co.uk/";
          this.propLinkReferer = "referrer=" + this.referrer + "/landing_page_social-media_FLINK_FOR-SALE_haart";
          break;
          case 'dar':
          this.logoUrl = 'assets/images/logos/darlows-white.png';
          this.brandPhoneNumber = '08002230336';
          this.brandPhoneNumberFormatted = '0800 223 0336';
          this.brandWebsiteLink = "https://www.darlows.co.uk/?utm_source=social-media&utm_medium=landing_page&utm_campaign=FLINK&utm_term=darlows&utm_content=FOR-SALE&referrer=landing_page_social-media_FLINK_FOR-SALE_darlows";
          this.brandName = "Darlows";
          this.brandFamilyLegalInfo = "https://www.darlows.co.uk/legal-information/family/";
          this.brandTnCLnk = "https://www.darlows.co.uk/legal-information/";
          this.brandPrivacyPolicy = "https://www.darlows.co.uk/legal-information/privacy-policy/";
          //this.propLinkReferer = "&referrer=landing_page_social-media_FLINK_FOR-SALE_darlows";
          this.baseSite = "https://www.darlows.co.uk/";
          this.propLinkReferer = "referrer=" + this.referrer + "/landing_page_social-media_FLINK_FOR-SALE_darlows"
          break;
          case 'hay':
          this.logoUrl = 'assets/images/logos/haybrook_white.png';
          // this.brandPhoneNumber = '08002230335';
          // this.brandPhoneNumberFormatted = '0800 223 0335';
          this.brandPhoneNumber = '03454810732';
          this.brandPhoneNumberFormatted = '0345 481 0732';
          this.brandWebsiteValuationLink = "https://www.haybrook.com/selling/request-valuation/?referrer=flinkHaybrook";
          this.brandWebsitePropertyLink = "https://www.haybrook.com/" + this.propRef;
          this.brandWebsiteLink = "https://www.haybrook.com/?utm_source=social-media&utm_medium=landing_page&utm_campaign=FLINK&utm_term=Haybrook&utm_content=FOR-SALE&referrer=landing_page_social-media_FLINK_FOR-SALE_Haybrook";
          this.brandName = "Haybrook";
          this.brandFamilyLegalInfo = "https://www.haybrook.com/legal-information/family/";
          this.brandTnCLnk = "https://www.haybrook.com/legal-information/";
          this.brandPrivacyPolicy = "https://www.haybrook.com/legal-information/privacy-policy/";
          //this.propLinkReferer = "&referrer=landing_page_social-media_FLINK_FOR-SALE_Haybrook";
          this.baseSite = "https://www.haybrook.com/";
          this.propLinkReferer = "referrer=" + this.referrer + "/landing_page_social-media_FLINK_FOR-SALE_Haybrook"
          break;
          case 'fjl':
          this.logoUrl = 'assets/images/logos/fjl-white.png';
          this.brandPhoneNumber = '02039183072';
          this.brandPhoneNumberFormatted = '0203 918 3072';
          this.brandWebsiteLink = "https://www.fjlord.co.uk/?utm_source=social-media&utm_medium=landing_page&utm_campaign=FLINK&utm_term=FJL&utm_content=FOR-SALE&referrer=landing_page_social-media_FLINK_FOR-SALE_FJL";
          this.brandName = "Felicity J. Lord";
          this.brandFamilyLegalInfo = "https://www.fjlord.co.uk/legal-information/family/";
          this.brandTnCLnk = "https://www.fjlord.co.uk/legal-information/";
          this.brandPrivacyPolicy = "https://www.fjlord.co.uk/legal-information/privacy-policy/";
          //this.propLinkReferer = "&referrer=landing_page_social-media_FLINK_FOR-SALE_FJL";
          this.baseSite = "https://www.fjlord.co.uk/";
          this.propLinkReferer = "referrer=" + this.referrer + "/landing_page_social-media_FLINK_FOR-SALE_FJL"
          break;
          case 'brh':
          this.logoUrl = 'assets/images/logos/brian-holt.png';
          this.brandPhoneNumber = '08002230334';
          this.brandPhoneNumberFormatted = '0800 223 0334';
          this.brandWebsiteLink = "https://www.brianholt.co.uk/?utm_source=social-media&utm_medium=landing_page&utm_campaign=FLINK&utm_term=FJL&utm_content=SOLD&referrer=landing_page_social-media_FLINK_SOLD_FJL";
          this.brandName = "Brian Holt";
          this.brandFamilyLegalInfo = "https://www.spicerhaart.co.uk/about-us/legal-information/family/";
          this.brandTnCLnk = "https://www.spicerhaart.co.uk/about-us/legal-information/";
          this.brandPrivacyPolicy = "https://www.spicerhaart.co.uk/about-us/legal-information/privacy-policy/";
          //this.propLinkReferer = "&referrer=landing_page_social-media_FLINK_FOR-SALE_Brian_Holt";
          this.baseSite = "https://www.spicerhaart.co.uk/";
          this.propLinkReferer = "referrer=" + this.referrer + "/landing_page_social-media_FLINK_FOR-SALE_Brian_Holt"
          break;
      }

      const yearDate = new Date();
      const yearString = yearDate.getFullYear();

      switch (brand) {
        case 'hrt':
          this.meta.addTag({ name: 'description', content: 'haart is the UK&#39;s largest independent lettings and estate agent. Find out how we can help you to find your dream property, sell or let your home.' });
          this.meta.addTag({ name: 'author', content: 'haart Estate Agents' });
          this.meta.addTag({ name: 'keywords', content: 'estate agents, letting agents' });
          this.meta.addTag({ name: 'copyright', content: 'Copyright haart ' + yearString });
          break;
        case 'dar':
          this.meta.addTag({ name: 'description', content: 'Darlows Estate Agents offers local knowledge and expertise of Cardiff and the surrounding areas.' });
          this.meta.addTag({ name: 'author', content: 'Darlows Estate Agents' });
          this.meta.addTag({ name: 'keywords', content: 'estate agents, letting agents' });
          this.meta.addTag({ name: 'copyright', content: 'Copyright Darlows ' + yearString });
          break;
        case 'hay':
          this.meta.addTag({ name: 'description', content: 'Haybrook independent lettings and estate agent. Find out how we can help you to find your dream property, sell or let your home.' });
          this.meta.addTag({ name: 'author', content: 'Haybrook Estate Agents' });
          this.meta.addTag({ name: 'keywords', content: 'estate agents, letting agents' });
          this.meta.addTag({ name: 'copyright', content: 'Copyright Haybrook ' + yearString });
          break;
        case 'fjl':
          this.meta.addTag({ name: 'description', content: 'Felicity J Lord is part of the UK&#39;s largest independent lettings and estate agents. Find out how we can help you to find your dream property, sell or let your home.' });
          this.meta.addTag({ name: 'author', content: 'Felicity J Lord Estate Agents' });
          this.meta.addTag({ name: 'keywords', content: 'estate agents, letting agents' });
          this.meta.addTag({ name: 'copyright', content: 'Copyright Felicity J Lord ' + yearString });
          break;
      }
    }




    fillData(propData: any[]) {
      if (propData.length > 0) {
        this.price = Number(propData[0].Price);
        this.beds = Number(propData[0].Beds);
        this.firstImage = propData[0].ImageURL;
        this.address = propData[0].Address1;
        this.location = propData[0].Location;
        this.floorplan = propData[0].ImageMDFloorplan;
        this.longitude = Number(JSON.parse(propData[0].LongLat).Long);
        this.latitude = Number(JSON.parse(propData[0].LongLat).Lat);
        //this.officeLongLat = JSON.parse(propData[0].OfficeLongLat).Lat + ',' + JSON.parse(propData[0].OfficeLongLat).Long;
        this.OfficeTel = propData[0].OfficeTel;
        this.OfficeAddress = propData[0].OfficeAddress;
        this.rndPropertyType = this.image_path + propData[0].PropImage;
        this.rndPropertyBeds = this.image_path + propData[0].BedroomImage;
        this.rndPropertyLounge = this.image_path + propData[0].SofaImage;
        this.rndPropertyBath = this.image_path + propData[0].BathImage;
        this.staffPicURL = this.formatStaffPhoto(propData[0].StaffPicURL);
        this.staffName = propData[0].StaffName;
        this.staffJobTitle = propData[0].StaffJobTitle;
        this.locationBuyers = propData[0].Stat1;
        this.soldHeader = propData[0].SoldHeader;
        this.longDescription = propData[0].LongDescription;
        this.descriptionIntro = propData[0].LongDescription.substring(0, 150) + '...';
        this.features = JSON.parse(propData[0].Features);
        window['dataLayer'][0] = {
          'bedrooms': Number(propData[0].Beds),
          'price': Number(propData[0].Price),
          'propertyType': Number(propData[0].PropType),
          'shortPostCode': propData[0].ShortPostCode
        };
      }
    }




    formatStaffPhoto(imageUrl: string) {

      if (imageUrl != null ) {
          imageUrl = imageUrl.toLowerCase();
          imageUrl = imageUrl.replace('http://', '');
          imageUrl = imageUrl.replace('https://', '');
          imageUrl = 'https://images.weserv.nl/?url=' + imageUrl + '&w=150&shape=circle';
      }

      return imageUrl;
    }

    //HRT DAR HAY
    googleTag() {
      (function (w, d, s, l, i) {
            w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            const f = <HTMLScriptElement>d.getElementsByTagName(s)[0];
            const j = <HTMLScriptElement>d.createElement(s);
            const dl = l !== 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-P9V82P');
    }

    //FJL
    // googleTag() {
    //   (function (w, d, s, l, i) {
    //         w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    //         const f = <HTMLScriptElement>d.getElementsByTagName(s)[0];
    //         const j = <HTMLScriptElement>d.createElement(s);
    //         const dl = l !== 'dataLayer' ? '&l=' + l : '';
    //         j.async = true;
    //         j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
    //         f.parentNode.insertBefore(j, f);
    //     })(window, document, 'script', 'dataLayer', 'GTM-N4H5GC');
    // }
}



// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/shared/property.service.ts